(() => {
  'use strict';
  const card = document.getElementById('bewild-honey-card');
  if (!card) return;
  // Explicit design-review mode only on the requested unpublished theme.
  // Does not claim sessions, change suppression, or emit analytics.
  const designPreview = card.dataset.themeId === '151221633068' && card.dataset.themeRole === 'unpublished'
    && new URLSearchParams(location.search).get('honey_card_preview') === '1';
  const path = location.pathname;
  const excluded = /\/(products|cart|checkouts?|account|accounts)(\/|$)|rice-comfort|connected-coffee|quiz|lead[-_]?magnet|finder/i;
  if (excluded.test(path) || /quiz|lead[-_]?magnet|finder|connected-coffee/i.test(card.dataset.template) || /product|cart|customers/.test(card.dataset.pageType)) return;
  const seenKey = 'bewild_promotion_seen', untilKey = 'bewild_honey_hidden_until';
  let visits;
  try {
    if (!designPreview && (sessionStorage.getItem(seenKey) || Number(localStorage.getItem(untilKey)) > Date.now())) return;
    visits = Number(sessionStorage.getItem('bewild_honey_visits') || 0) + 1;
    if (!designPreview) sessionStorage.setItem('bewild_honey_visits', String(visits));
  } catch (_) { return; }
  const link = card.querySelector('[data-honey-cta]');
  try {
    const url = new URL(link.href, location.origin);
    if (!/^https?:$/.test(url.protocol)) return;
    Object.entries({utm_source:'bewild',utm_medium:'onsite',utm_campaign:'coffee_blossom_honey_launch',utm_content:'announcement_card'}).forEach(([k,v]) => url.searchParams.set(k,v));
    link.href = url.href;
  } catch (_) { return; }
  let elapsed = 0, last = performance.now(), shown = false, finished = false, scrolled = false;
  let active = !document.hidden && document.hasFocus();
  const delay = Math.max(0, Number(card.dataset.delay) || 15) * 1000;
  const actions = new Set();
  function track(action) {
    if (designPreview || actions.has(action)) return;
    actions.add(action);
    const data = {product_id: card.dataset.productId, campaign: 'coffee_blossom_honey_launch', creative: 'option_1', theme_id: card.dataset.themeId};
    // The existing Shopify pixel bus handles consent and event delivery.
    // This is a custom engagement event, never Lead, AddToCart, or Purchase.
    try {
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        window.Shopify.analytics.publish('bewild:honey_card_' + action, data);
        card.dataset.lastEvent = 'honey_card_' + action;
      }
    } catch (_) {}
    // Match the existing coupon's local event journal, without visitor or page data.
    try {
      const key = 'bewild_honey_events';
      const events = JSON.parse(localStorage.getItem(key) || '[]');
      events.push({name:'honey_card_' + action, timestamp:new Date().toISOString()});
      localStorage.setItem(key, JSON.stringify(events.slice(-30)));
    } catch (_) {}
  }
  function visible(el) {
    const style = getComputedStyle(el), r = el.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
  }
  function blocked() {
    const focused = document.activeElement;
    if (focused && !card.contains(focused) && focused.closest('form,input,textarea,select,[contenteditable="true"]')) return true;
    return [...document.querySelectorAll('[aria-modal="true"],dialog[open],.popup.is-open,.drawer.is-open,[data-bewild-coupon-popup].is-visible,[class*="modal"].is-open,[class*="drawer"].is-open')].some(visible);
  }
  function position() {
    // Reserve space above visible fixed/sticky controls, including third-party frames.
    card.style.visibility = 'hidden'; card.hidden = false; card.style.bottom = '100px';
    let bottom = 100;
    const cr = card.getBoundingClientRect();
    for (const el of document.querySelectorAll('body *')) {
      if (el === card || card.contains(el) || el.contains(card)) continue;
      const style = getComputedStyle(el);
      if (!['fixed','sticky'].includes(style.position) || !visible(el)) continue;
      const r = el.getBoundingClientRect();
      if (r.right <= cr.left || r.left >= cr.right || r.bottom < innerHeight / 2) continue;
      bottom = Math.max(bottom, innerHeight - r.top + 16);
    }
    card.style.bottom = bottom + 'px';
    const fits = card.getBoundingClientRect().top >= 80;
    card.hidden = !fits; card.style.visibility = '';
    return fits;
  }
  function clock() {
    const now = performance.now();
    if (active) elapsed += now - last;
    last = now;
    active = !document.hidden && document.hasFocus();
  }
  function tick() {
    clock();
    if (finished) return;
    const height = document.documentElement.scrollHeight - innerHeight;
    if (height > 0 && scrollY / height >= .25) scrolled = true;
    if (shown) {
      if (!active || blocked()) card.hidden = true;
      else position();
      return;
    }
    if (!active || (!designPreview && (elapsed < delay || !(scrolled || visits >= 2))) || blocked()) return;
    try { if (!designPreview && (sessionStorage.getItem(seenKey) || Number(localStorage.getItem(untilKey)) > Date.now())) return; } catch (_) { return; }
    if (!position()) return;
    if (!designPreview && !window.bewildPromotion.claim('honey')) { card.hidden = true; finished = true; return; }
    shown = true;
    track('impression');
  }
  function finish(action) {
    if (!shown || finished) return;
    finished = true; card.hidden = true;
    try { if (!designPreview) localStorage.setItem(untilKey, String(Date.now() + 7 * 86400000)); } catch (_) {}
    track(action); clearInterval(interval);
  }
  card.querySelector('[data-honey-close]').addEventListener('click', () => finish('dismissal'));
  link.addEventListener('click', () => finish('cta_click'));
  link.addEventListener('auxclick', e => { if (e.button === 1) finish('cta_click'); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !card.hidden) finish('dismissal'); });
  document.addEventListener('visibilitychange', clock);
  window.addEventListener('focus', clock); window.addEventListener('blur', clock);
  const interval = setInterval(tick, 500);
})();
